import { ReactNode, ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown, SignOutAlt, UserIcon } from '@bancobarigui/barihaus';
import { StyledContainer, StyledContent, StyledBarihausLayout, UserName, UserIconButton, UserMenuItemLabel, UserDropdownGlobalStyle, UserTrigger } from './styles';
import { useAuth } from '../../hooks/auth';
import { MENU_ITEMS } from '../../constants/menu-items';

interface IChildren {
  children: ReactNode;
}

const Layout = ({ children }: IChildren): ReactElement => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleMenuClick = (path: string) => {
    navigate(path);
  };

  const handleLogout = () => {
    signOut();
    navigate('/');
  };

  const userMenuItems = {
    items: [
      {
        key: 'logout',
        label: (
          <UserMenuItemLabel onClick={handleLogout}>
            Sair
            <SignOutAlt />
          </UserMenuItemLabel>
        ),
      },
    ],
  };

  const userDropdown = (
    <>
      <UserDropdownGlobalStyle />
      <Dropdown menu={userMenuItems} trigger={['click']} placement="bottomRight" rootClassName="user-dropdown-menu">
        <UserTrigger>
          <UserName>{user?.name}</UserName>
          <UserIconButton>
            <UserIcon />
          </UserIconButton>
        </UserTrigger>
      </Dropdown>
    </>
  );

  return (
    <StyledBarihausLayout
      menuItems={MENU_ITEMS}
      onMenuClick={handleMenuClick}
      isSearch={false}
      siderWidth={268}
      headerHeight={56}
      siderCollapsible
      user={{ name: '' }}
      headerContent={userDropdown}
    >
      <StyledContainer>
        <StyledContent>
          {children}
        </StyledContent>
      </StyledContainer>
    </StyledBarihausLayout>
  );
};

export default Layout;
